import type { ConversationArtifact } from "~/ai-chat/model/conversation-artifacts";
import { extensionOf } from "~/ai-chat/model/save-resource-action";
import { ChatArtifactCard } from "~/ai-chat/ui/chat-artifact-card";

interface ChatArtifactListProps {
  artifacts: ConversationArtifact[];
  onOpen: (artifact: ConversationArtifact) => void;
}

// The Artifacts pane: every tracked asset the conversation surfaced, one card each,
// opening it in the canvas. Version/size aren't shown — chat saves mint separate
// resources (no shared revision history) and a per-card fetch isn't worth it here.
export function ChatArtifactList({ artifacts, onOpen }: ChatArtifactListProps) {
  if (artifacts.length === 0) {
    return (
      <div className="text-muted-foreground flex min-h-0 flex-1 items-center justify-center px-6 text-center text-sm">
        No artifacts in this conversation yet.
      </div>
    );
  }
  return (
    <div className="flex min-h-0 flex-1 flex-col gap-3 overflow-y-auto p-4">
      {artifacts.map((artifact) => (
        <ChatArtifactCard
          key={artifact.resourceId}
          name={artifact.name}
          kind={extensionOf(artifact.name)}
          onOpen={() => onOpen(artifact)}
        />
      ))}
    </div>
  );
}
